module.exports = __webpack_public_path__ + "static/media/commentthread.24f62f97.png";